import {createRouter, createWebHistory} from 'vue-router';

import FetchGithubAccessToken from '@/General/views/FetchGithubAccessToken.vue';
import FetchOpenidAccessToken from '@/General/views/FetchOpenidAccessToken.vue';
import Home from '@/General/views/Home.vue';
import SignIn from '@/General/views/SignIn.vue';

export default createRouter({
  history: createWebHistory(),
  routes: [
    {path: '/', component: Home},
    {path: '/sign-in', component: SignIn},
    {path: '/fetch-github-access-token', component: FetchGithubAccessToken},
    {path: '/fetch-openid-access-token', component: FetchOpenidAccessToken},
  ]
});
